import { styled, css } from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const Trigger = styled.button`
  ${({ theme: { borderRadius, colors, fontSizes, fontWeights } }) => css`
    align-items: center;
    background: transparent;
    border: none;
    border-radius: ${borderRadius.sm};
    box-shadow: 0 0 0 1px ${colors.brandDarkAlpha20};
    cursor: pointer;
    display: flex;
    gap: 0.5rem;
    height: 2rem;
    width: max-content; /* Ensures the button hugs the text and icon precisely */
    padding: 0 0.75rem;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    .icon {
      flex-shrink: 0;
      width: 1.25rem;
    }

    span.trigger-label {
      color: ${colors.brandDark};
      flex: 1;
      font-family: inherit;
      font-size: ${fontSizes.s12};
      font-weight: ${fontWeights.medium};
      text-align: left;
      white-space: nowrap;
    }

    .chevron-icon {
      transform: rotate(0deg);
      transition: transform 0.2s ease;
      width: 1.25rem;
    }

    &[data-open='true'] .chevron-icon {
      transform: rotate(180deg);
    }
  `}
`;

export const DropdownPanel = styled.div`
  ${({ theme: { colors, spacings } }) => css`
    background: ${colors.brandLight};
    border-radius: 0.25rem;
    box-shadow:
      0 0 0 1px ${colors.brandDarkTint80},
      0 0.75rem 0.5rem -0.25rem rgba(32, 30, 36, 0.15),
      0 0.25rem 0.25rem -0.125rem rgba(32, 30, 36, 0.2);
    min-width: 18rem;
    overflow: visible;
    padding: ${spacings.s8};
    z-index: 100;
    width: max-content;
  `}
`;

export const RadioGroupWrapper = styled.div`
  ${({ theme: { spacings } }) => css`
    padding: 0 ${spacings.s12};

    .radio {
      align-items: center;
      gap: 0.5rem;
      margin: 0;
      min-height: unset;
      padding-left: unset;

      input[type='radio'] {
        float: unset;
        margin-left: unset;
      }
    }
  `}
`;

export const OptionList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`;

export const PresetRow = styled.div`
  ${({ theme: { colors } }) => css`
    align-items: center;
    cursor: pointer;
    display: flex;
    width: 100%;
    padding: 0.5rem 0.75rem;
    margin: 0 -0.75rem;
    border-radius: 0.25rem;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: ${colors.brandDarkAlpha5};
    }

    .icon {
      flex-shrink: 0;
      width: 1.25rem;
    }
  `}
`;

export const DateContainer = styled.span`
  ${({ theme: { colors, fontSizes, fontWeights } }) => css`
    color: ${colors.brandDark};
    font-size: ${fontSizes.s16};
    font-weight: ${fontWeights.regular};
    margin-left: 0.5rem;
  `}
`;

export const CalendarFloating = styled.div`
  overflow: visible;

  .date-picker {
    overflow: visible;

    button {
      border: none;
      height: 0;
      min-height: 0;
      opacity: 0;
      overflow: hidden;
      padding: 0;
      pointer-events: none;
      width: 0;
    }
  }
`;
